import React from 'react';

const PRIORITY = {
  Low:      { dot: 'var(--accent)', label: 'var(--accent)' },
  Medium:   { dot: '#D97706', label: '#D97706' },
  High:     { dot: '#DC2626', label: '#DC2626' },
  Urgent:   { dot: '#BE123C', label: '#BE123C' },
  Critical: { dot: '#7F1D1D', label: '#991B1B' },
};

export default function PriorityBadge({ priority }) {
  const c = PRIORITY[priority] || { dot: '#718096', label: '#718096' };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      <div style={{ width: 7, height: 7, borderRadius: '50%', background: c.dot, flexShrink: 0 }} />
      <span style={{ fontSize: 11, color: c.label, fontWeight: 600 }}>{priority}</span>
    </div>
  );
}
